/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface DeleteAdditionalCost$Params {
  additionalCostId: number;
}

export function deleteAdditionalCost(
  http: HttpClient,
  rootUrl: string,
  params: DeleteAdditionalCost$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, deleteAdditionalCost.PATH, 'delete');
  if (params) {
    rb.path('additionalCostId', params.additionalCostId, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    }),
  );
}

deleteAdditionalCost.PATH = '/service/v1/afterSales/additionalCosts/{additionalCostId}';
